import * as Sentry from '@sentry/browser'
import brandStyler from '@/utils/brand-styler'

export default {
  data () {
    return {
      passwordStatus: {
        refresh: 1,
        required: false,
        title: null,
        password: null
      },
      errorMessage: null,
      errorCode: 0
    }
  },
  computed: {
    showPasswordDialog () {
      return this.passwordStatus.required
    }
  },
  methods: {
    getEnvelope (password) {
      return this.$store.dispatch('getEnvelope', { query: this.$route.query, password, widgetCode: this.$route.params.widgetCode }).then((response) => {
        const data = response.data
        this.passwordStatus.required = false

        if (password) this.passwordStatus.password = password

        if (data.hasBranding) {
          brandStyler(data.colours)
        }
        return response
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          this.passwordStatus.required = true
          this.passwordStatus.title = error.response.data.title
          this.passwordStatus.incorrect = !!password
          this.passwordStatus.refresh++ // TODO Fix reactvitity issues in a better way
          throw error
        } else if (error.response) {
          this.errorMessage = error.response.data.message
          this.errorCode = error.response.status
          Sentry.captureException(error.response)
          this.$router.push({ name: 'PageError', params: { errorMessage: this.errorMessage, errorCode: this.errorCode } })
        } else {
          this.errorMessage = error.message || error
          this.errorCode = 0
          Sentry.captureException(error, {
            extra: error
          })

          this.$router.push({ name: 'PageError', params: { errorMessage: this.errorMessage, errorCode: this.errorCode } })
        }
      })
    }
  }
}
